import { HttpContextToken } from '@angular/common/http';

export const BYPASS_AUTH = new HttpContextToken(() => false);
